import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useSelector, useDispatch } from "react-redux";
import { actions as menuActions } from "@store/menu/reducer";
import "./style.css";
import SubCategoryTabList from "@components/sub-category-tab-list";
import { UiAction } from "@store/ui/reducer";
import { Divider } from "@mui/material";
import { backdropStyle } from "../../containers/payment/constant";

function Categories(props) {
  const { selectedTab } = useSelector((state) => state.menu);
  const menuData = useSelector((state) => state.menu);
  const menu = menuData.menu || [];

  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    const element = document.getElementById("outlet-cover-image");
    // element.scrollIntoView();
    dispatch(menuActions.updateSelectedTab(newValue));
    dispatch(menuActions.updateSelectedSubCategoryTab(0));
  };

  useEffect(() => {
    dispatch(menuActions.updateSelectedTab(0));
    dispatch(menuActions.updateSelectedSubCategoryTab(0));
    dispatch(UiAction.toggleStickyHeader(false));
  }, []);

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
      }}
      className="categories"
    >
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        variant="scrollable"
        aria-label="scrollable prevent tabs example"
        scrollButtons
        allowScrollButtonsMobile
      >
        {menu.categories.map((category) => (
          <Tab
            label={category.name}
            {...a11yProps(category.categoryId)}
            key={category.categoryId}
          />
        ))}
      </Tabs>

      <SubCategoryTabList />
    </Box>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default Categories;
